<template>
  <div class="dataList">
    <Row class="bottomCal" type="flex" justify="start">
      <Col span="24" class="colCall">
        <div class="card">
          <Card class="info">
            <h3>基本信息</h3>
            <p>服务名称 ： {{ datas.title }}</p>
            <p>接口地址 ： {{ datas.urlL }}</p>
            <p>备注 ： {{ datas.apiRemark }}</p>
            <p>表名 ： {{ datas.layername }}</p>
            <p>权限 ： {{ datas.apiResource == 1 ? "公有" : "私有" }}</p>
            <p>创建时间 ： {{ datas.createTime }}</p>
            <p>更新时间 ： {{ datas.updateTime }}</p>
          </Card>
          <Card class="infoList">
            <h3>输入字段 :</h3>
            <div class="table-box">
              <Table
                border
                ref="resTable"
                :columns="inputColumns"
                :data="inputTablesList"
                max-height="160"
              >
              </Table>
            </div>
          </Card>
          <Card class="infoList">
            <h3>输出字段 :</h3>
            <div class="table-box">
              <Table
                border
                ref="resTable"
                :columns="outColumns"
                :data="outTablesList"
                max-height="160"
              >
              </Table>
            </div>
          </Card>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import showdetail from "./showdetail.js";
export default showdetail;
</script>

<style lang="less" scoped>
.dataList {
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  .bottomCal {
    width: 100%;
    overflow: auto;
    .colCall {
      height: 100%;
      .card {
        height: 100%;
      }
    }
  }
}
.infoList {
  height: 33%;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftmenu/layers/showDatial/showdetail.vue